export enum PreferredFreelancerBadgeType {
  PREFERRED_FREELANCER = 'preferred-freelancer-v3.svg',
}
